import { Select } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useDealDocumentTemplatesQuery } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/api/useDealDocumentTemplatesQuery.ts';

interface Props {
	dealId: string;
	value?: string;
	onChange: (next: string | null) => void;
}

export const TemplatePicker = ({ dealId, value, onChange }: Props) => {
	const tMipManage = useTranslationMipManage();
	const { data: options, isPending, isError } = useDealDocumentTemplatesQuery(dealId);

	// A deal with no available templates is the common case early on (availability is opt-in
	// per deal) — an empty, enabled dropdown reads as broken, so disable and explain instead.
	const hasNoTemplates = !isPending && !isError && (options?.length ?? 0) === 0;

	let placeholder = tMipManage('master_documents.text.template_placeholder');
	if (isPending) {
		placeholder = tMipManage('master_documents.text.template_loading');
	} else if (hasNoTemplates) {
		placeholder = tMipManage('master_documents.text.template_empty');
	}

	return (
		<Select
			label={tMipManage('master_documents.text.template_label')}
			placeholder={placeholder}
			data={options ?? []}
			value={value ?? null}
			onChange={onChange}
			disabled={isPending || isError || hasNoTemplates}
			error={isError ? tMipManage('master_documents.text.template_error') : undefined}
			searchable
			nothingFoundMessage={tMipManage('master_documents.text.template_empty')}
		/>
	);
};
